import { useMemo } from 'react';
import { useNetworkContext } from '../modules/offline/contexts/network/network.context';
import { useHandleHydrateOfflineDatabase } from '../modules/offline/database/hooks/useHandleHydrateOfflineDatabase';
import { useOfflineQueryClientAlreadyHydratedInFirstRender } from '../modules/offline/queryClient/hooks/useOfflineQueryClientAlreadyHydratedInFirstRender';
import storage from './useStorage/useStorage';

export const useIsLoadingApp = () => {
  const offlineQueryClientAlreadyHydratedInFirstRender =
    useOfflineQueryClientAlreadyHydratedInFirstRender();
  const { isLoadingOnlineStatus, isForcingOfflineMode, userHasInternet } = useNetworkContext();

  const teamId = storage.getTeamId();

  const shouldForceInitializeOfflineDatabase = !userHasInternet && !!teamId;

  const { isHydrated: isOfflineDatabaseHydrated } = useHandleHydrateOfflineDatabase({
    runOnce: true,
    forceInitialize: shouldForceInitializeOfflineDatabase,
  });

  const isLoadingApp = useMemo(() => {
    if (isLoadingOnlineStatus) {
      return true;
    }

    if (isForcingOfflineMode && !offlineQueryClientAlreadyHydratedInFirstRender) {
      return true;
    }

    if (shouldForceInitializeOfflineDatabase && !isOfflineDatabaseHydrated) {
      return true;
    }

    return false;
  }, [
    isLoadingOnlineStatus,
    isForcingOfflineMode,
    offlineQueryClientAlreadyHydratedInFirstRender,
    userHasInternet,
    isOfflineDatabaseHydrated,
  ]);

  return isLoadingApp;
};
